const isFullArray = (value) => Array.isArray(value) && value.length > 0;

export default isFullArray;
